import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/** Component for displaying the space reports list. */
@ngCore.Component({
  imports: [ds.layout.page.Component, ds.table.Component],
  selector: 'atn-space-reports',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.reports.Collection} */
  public readonly reportsEc = ngCore.inject(state.space.reports.Collection)

  /** Canonical table input for Space reports. */
  public readonly tableConfig = {
    collection: this.reportsEc,
    view: { search: true, title: 'Reports' },
  } satisfies ds.table.ec.Config.Input<state.space.reports.TypeParams>
}
